import React from "react";
import "./VCMessage.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import { vcsList } from "../../data/vcData";

const VCMessage = () => {
  const latestVC = vcsList[vcsList.length - 1];

  return (
    <div id="vc-message-unique-page">
      <Navbar />

      <div id="vc-message-unique-container">
        {/* Header */}
        <div id="vc-page-unique-header">
          <h1>Message from the Vice-Chancellor</h1>
          <div id="vc-header-unique-underline"></div>
          <p className="vc-quote">
            "Education is not the learning of facts, but the training of the mind to think."
          </p>
        </div>

        {/* Content */}
        <div id="vc-content-unique-wrapper">
          {/* Profile */}
          <div id="vc-profile-unique-section">
            <div id="vc-image-unique-container">
              <img src={latestVC.image} alt={latestVC.name} />
            </div>

            <div id="vc-details-unique-info">
              <h2>{latestVC.name}</h2>
              <p id="vc-designation-unique">Vice-Chancellor</p>
             
              <p id="vc-university-unique">Rayalaseema University, Kurnool</p>
            </div>
          </div>

          {/* Message */}
          <div id="vc-message-unique-content">
            <div id="vc-message-unique-body">
              <p>
                It is my proud privilege to serve as the Vice-Chancellor of
                Rayalaseema University, Kurnool-an institution that stands for
                academic excellence, social responsibility, and holistic
                development.
              </p>

              <p>
                Rayalaseema University is committed to nurturing intellectual
                curiosity, innovation, and ethical leadership among its
                students. We strive to create a learning environment that
                empowers students with knowledge, skills, and values required
                to meet global challenges.
              </p>

              <p>
                Our dedicated faculty members continuously engage in teaching,
                research, and community service, ensuring that our academic
                practices remain relevant and impactful. We actively promote
                interdisciplinary research and industry collaboration to
                enhance real-world learning.
              </p>

              <p>
                As we move forward, the University will continue to expand its
                academic programmes, strengthen research infrastructure, and
                foster international partnerships. Our focus remains on quality
                education, digital transformation, and student-centered
                learning.
              </p>

              <p>
                I extend my sincere appreciation to all stakeholders — faculty,
                staff, students, alumni, and partners — for their unwavering
                commitment in shaping Rayalaseema University as a centre of
                excellence.
              </p>

              {/* Closing */}
              <div id="vc-closing-unique-section">
                <p>With best regards,</p>
                <p id="vc-signature-unique-name">{latestVC.name}</p>
                <p id="vc-signature-unique-title">Vice-Chancellor</p>
                <p id="vc-signature-unique-university">
                  Rayalaseema University, Kurnool
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default VCMessage;
